var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53_15018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7208 10.9749V15.8525M14.7208 20.7301H14.733M12.6356 4.70717L2.30729 21.9495C2.09434 22.3183 1.98167 22.7364 1.98048 23.1622C1.97929 23.5881 2.08962 24.0068 2.30049 24.3768C2.51137 24.7467 2.81545 25.055 3.18247 25.271C3.54948 25.4869 3.96665 25.603 4.39247 25.6077H25.0491C25.4749 25.603 25.8921 25.4869 26.2591 25.271C26.6261 25.055 26.9302 24.7467 27.1411 24.3768C27.352 24.0068 27.4623 23.5881 27.4611 23.1622C27.4599 22.7364 27.3472 22.3183 27.1343 21.9495L16.806 4.70717C16.5886 4.3488 16.2825 4.0525 15.9173 3.84687C15.552 3.64123 15.1399 3.5332 14.7208 3.5332C14.3016 3.5332 13.8896 3.64123 13.5243 3.84687C13.1591 4.0525 12.853 4.3488 12.6356 4.70717Z",
    stroke: "#C6450C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53_15018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.2656,
    height: 29.2656,
    fill: "white",
    transform: "translate(0.0898438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionicon);
export default __webpack_public_path__ + "static/media/actionicon.dcf590c1329abb50d4245f1c35a19b4f.svg";
export { ForwardRef as ReactComponent };